'use client'

import dynamic from 'next/dynamic'

import { Loading } from '../../../loading'

export const ProductPrescriptionDialogDynamicContent = dynamic(
  async () =>
    import('./ProductPrescriptionDialogContent').then(
      (mod) => mod.ProductPrescriptionDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
